export default __webpack_public_path__ + "static/media/logo.fce80ac9.svg";